import uuid from 'react-uuid';

const SESSION_UUID = `session-uuid_${process.env.REACT_APP_ID}`;
const ED_ATTEMPT = `r_ed_${process.env.REACT_APP_ID}`;
const FJ_PRE = `fj_pre_${process.env.REACT_APP_ID}`;
const FJ_POST = `fj_post_${process.env.REACT_APP_ID}`;

const getSessionUuid = (): string | null => sessionStorage.getItem(SESSION_UUID);
const getEdAttempt = (): string | null => sessionStorage.getItem(ED_ATTEMPT);
const getFjPre = (): string | null => sessionStorage.getItem(FJ_PRE);
const getFjPost = (): string | null => sessionStorage.getItem(FJ_POST);

const setSessionUuid = (value: string): void => sessionStorage.setItem(SESSION_UUID, value);
const setEdAttempt = (value: string): void => sessionStorage.setItem(ED_ATTEMPT, value);
const setFjPre = (value: string): void => sessionStorage.setItem(FJ_PRE, value);
const setFjPost = (value: string): void => sessionStorage.setItem(FJ_POST, value);

export const getSessionKey = () => {
  if (getSessionUuid()) {
    return getSessionUuid();
  }

  const key = uuid();
  setSessionUuid(key);

  return key;
};

export { getEdAttempt, getFjPre, getFjPost, setEdAttempt, setFjPre, setFjPost };
